import { useAuth } from '@auth/use-auth'
import { useSubmitSignin } from '@auth/use-submit-signin'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { Navigate } from 'react-router-dom'

export const SignIn = () => {
  const [organizationId, setOrganizationId] = useState('')
  const [password, setPassword] = useState('')

  const { initialized, userName: cachedName, loading } = useAuth()
  const { error, submit } = useSubmitSignin()

  const handleSubmit = (event) => {
    event.preventDefault()
    submit({ organizationId, password })
  }

  const isSubmitDisabled = loading || !organizationId.trim() || !password

  if (initialized && cachedName) {
    return <Navigate to="/" />
  }

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{ height: '100%', width: '100%', backgroundColor: '#80808030' }}
    >
      <Container
        maxWidth="xs"
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Paper elevation={4} sx={{ pt: 4, pl: 4, pr: 4, pb: 4 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <img
              style={{ marginLeft: 24 }}
              src="/sib-logo.png"
              alt="SIB"
              width={60}
              height={40}
            />
            <Typography component="h1" variant="h5" sx={{ pt: 4 }}>
              SIB authorization
            </Typography>
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                value={organizationId}
                id="organizationId"
                label="Organization ID"
                name="organizationId"
                autoComplete="organizationId"
                autoFocus
                onChange={(e) => setOrganizationId(e.target.value)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                value={password}
                type="password"
                name="password"
                label="Password"
                id="password"
                autoComplete="password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={isSubmitDisabled}
                sx={{ mt: 3, mb: 1 }}
              >
                Sign In
              </Button>
            </Box>
            {error && (
              <Stack
                direction="row"
                spacing={1}
                sx={{
                  color: 'error.main',
                  alignItems: 'center',
                }}
              >
                <ErrorOutlineOutlinedIcon />
                <Typography
                  sx={{
                    textAlign: 'left',
                  }}
                >
                  {error}
                </Typography>
              </Stack>
            )}
          </Box>
        </Paper>
      </Container>
    </Container>
  )
}
